module.exports = __webpack_public_path__ + "img/twitter-logo-white.3bc39d71.svg";